import { createDrawer } from '../../legacy/overlay.js';

/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data() {
        return {
            circle_id: 0, //圈子id
            circle:null,
            default_circle_id: 0,
            moment_id:0,
            title:'',
            content:'',
            momentType:'', //帖子类型 比如投票等等
            momentTag:'',
            searchText:'', //搜索词
            toolType:'', //工具栏点击类型
            circleList:[],
            topicList:[],
            selectorTabs:[],
            selectorTabIndex:0,
            selectorList:[],
            scroll:'',
            showEmoji:false,
            locked:false,
            circleSelectorShow:false, //圈子话题选择
            loading:false,
            composing:false, //用于判断是否中文打字输入
            typingTimer: null,
            image: {
                allow: true, //是否允许添加图片
                list: [],
                count: 9,
            },
            video: {
                allow: true,
                list: [],
                thumb:{},
                count: 0,
            },
            privacy: {
                type:'none',
                value:'',
                roles:[],
                content:'',
                list:{
                    none:{
                        text:'公开',
                        icon:'ri-earth-line',
                    },
                    money:{
                        text:'付费',
                        icon:'ri-money-cny-circle-line',
                    },
                    credit:{
                        text:'积分',
                        icon:'ri-coin-line',
                    },
                    login:{
                        text:'登录',
                        icon:'ri-login-circle-line',
                    },
                    comment:{
                        text:'评论',
                        icon:'ri-chat-2-line',
                    },
                    password:{
                        text:'密码',
                        icon:'ri-lock-password-line',
                    },
                    // fans:{
                    //     text:'粉丝',
                    //     icon:'ri-group-line',
                    // },
                    roles:{
                        text:'限制等级',
                        icon:'ri-vip-diamond-line',
                    },
                }
            },
            editor:{ //编辑器功能
                media_size:null,
                toolbar:[]
            },
            currentUser:{
                media_role:null,
                type_role:null,
                privacy_role:null,
            },
            show:false
        }
    },
    computed:{
        defaultSelectorList() {
            return [{
                icon:false,
                name:this.searchText ? this.searchText:'创建新圈子',
                desc:this.toolType == 'topic' ? '创建自定义话题':'创建专属自己的圈子'
            }];
        },
        numberLimit() {
            return { //数量限制
                maxTitke:50,
                titleLength:this.title.length,
                minContent:5,
                maxContent:800,
                contentLength:this.content.length,
            }
        },
        submitdisabled() {
            if(this.locked) return true;
            if(this.numberLimit.contentLength < this.numberLimit.minContent || this.numberLimit.contentLength > this.numberLimit.maxContent) return true;
        },
    },
    mounted(){
        if(!this.$refs.circleEditor) return;
        
        if(typeof qk_circle !== 'undefined') {
            
            if(qk_circle.id !== '0') {
                this.circle_id = this.default_circle_id = qk_circle.id;
                this.circle = qk_circle;
            }
            this.show = typeof qk_circle.showEditor !== 'undefined' ? true : false
        }
        
        //自动高度
        autosize(this.$refs.momentContent);
        
        this.getUserCircleCapabilities();
        this.getEditMomentData();
    },
    methods:{
        //获取用户在当前圈子能力及编辑器设置
        getUserCircleCapabilities(){
            this.$http.post(qk_rest_url+'getUserCircleCapabilities','circle_id='+this.circle_id).then(res=>{
                this.editor = res.data.editor
                delete res.data.editor
                this.currentUser = res.data
            }).catch((err) => {
                qkShowApiError(err, '加载编辑器权限失败');
            })
        },
        async submitMoment(){
            if(this.locked === true) return
            this.locked = true
            await this.videoThumbUpload();
            
            let { list, ...privacy } = this.privacy;
            
            let contentHidden = this.privacy.content.length > 0 ? '[content_hide]'+this.privacy.content+'[/content_hide]' : '';
            
            let data = {
                'moment_id':this.moment_id,
                'type':this.momentType,
                'circle_id':this.circle_id,
                'title':this.$refs.momentTitle.value,
                'content':this.$refs.momentContent.value + contentHidden,
                'tag':this.momentTag,
                'image':this.image.list,
                'video':this.video.list.map((value, index) => {
                    return {
                        id:value.id,
                        url:value.url,
                        thumb:this.video.thumb.url
                    };
                }),
                'privacy':privacy
            }

            this.$http.post(qk_rest_url+'insertMoment',data).then(res=>{
                //CircleList.data.unshift(res.data)
                this.$message({ message: res.data.msg, type: 'success' });
                this.restData()
                
                if(window.qkMomentList?.$refs.momentList) {
                    window.qkMomentList.$refs.momentList.insertAdjacentHTML('afterbegin', res.data.data);
                    this.$nextTick(()=>{
                        qkUpdateLazyLoad()
                        new Packery('.circle-moment-list.qk-waterfall')
                        window.qkMomentList.updateVideoPlayer()
                    })
                }
                this.locked = false
            }).catch(err=>{
                this.locked = false
                this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
            })
        },
        restData(){
            let resetData = this.$options.data.bind(this)();//this.$options.data.call(this); // 获取组件的初始数据

            // 指定要重置的键元素
            let keysToReset = ['title', 'content', 'privacy', 'video', 'image', 'momentTag', 'momentType'];
            
            // 创建一个新的对象，包含要重置的键和对应的初始值
            let newData = {};
            keysToReset.forEach(key => {
                newData[key] = resetData[key];
            });
            
            Object.assign(this.$data, newData); // 将新的数据合并到组件的数据中
        },
        selectorTabChange(index) {
            this.selectorTabIndex = index;
            
            if(this.circleList[this.selectorTabIndex].list.length) {
                this.selectorList = this.circleList[this.selectorTabIndex].list;
            }else{
                this.selectorList = this.defaultSelectorList
            }
            
            this.TabscrollTo(index);
        },
        selector(item) {
            if(item.id) {
                if(this.toolType == 'topic') {
                    //this.$refs.momentContent.value += "#"+ item.name +"#";
                    this.content += "#"+ item.name +"#";
                    this.$refs.momentContent.focus();
                //圈子页面发表不允许选择圈子
                }else if(!this.default_circle_id){
                    if(item.in_circle || !item.is_join_circle_post) {
                        this.momentTag = ''
                        this.circle = item;
                        this.circle_id = item.id;
                    }else{
                        return this.$message({ message: `您还没加入该[${item.name}]，无法选中`, type: 'warning' });
                    }
                }
                
                this.toolType = ''
            }
            
        },
        //创建圈子或话题
        create(item){
            
            if(!this.currentUser.can_create_circle) return this.$message({ message: `您当前无权创建[${item.name}]`, type: 'warning' }); 
            
            if(this.toolType == 'topic'){
                this.$createModal('createTopic',{
                    loading:false,
                    keepAlive:false,
                    props:{
                        name:item.name // 传递给组件的props
                    }
                })
            }else{
                createDrawer({componentName:'circleManage',componentProps: {
                    type: 'create' // 传递给组件的props
                }})
            }
        },
        getSearchCircle() {
            if(!this.searchText.trim()) return;
            this.loading = true;
            this.$https.post(qk_rest_url+'getSearchCircle',{
                'keyword':this.searchText.trim(),
                'type': this.toolType
            }).then(res=>{
                if( this.searchText && res.data.length) {
                    this.selectorList = res.data
                }else{
                    this.selectorList = this.defaultSelectorList
                }
                
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
                qkShowApiError(err, '搜索失败');
            })
        },
        getHotCircles() {
            this.loading = true;
            this.$https.post(qk_rest_url+'getAllCircles').then(res=>{
                this.circleList = res.data.list;
                this.selectorTabs = res.data.cats;
                
                if(this.circleList[this.selectorTabIndex].list.length) {
                    this.selectorList = this.circleList[this.selectorTabIndex].list;
                }else{
                    this.selectorList = this.defaultSelectorList
                }
                
                this.loading = false;
                
                this.$nextTick(() => {
                    if(this.$refs.scrollTab) {
                        this.scroll = new BScroll(this.$refs.scrollTab, {
                            scrollX: true,
                            probeType: 3, // listening scroll event
                            click:true    
                        })
                    }
                });
            }).catch((err) => {
                this.loading = false;
                qkShowApiError(err, '加载圈子列表失败');
            })
        },
        getTopics() {
            this.loading = true;
            this.$https.post(qk_rest_url+'getTopics').then(res=>{
                this.selectorList = this.topicList = res.data.list;
                
                this.loading = false;
                
            }).catch((err) => {
                this.loading = false;
                qkShowApiError(err, '加载话题失败');
            })
        },
        toolClick(type) {
            
            if(this.toolType == type || (this.default_circle_id && type == 'circle_cat')) {
                this.toolType = ''
                return;
            }
            
            this.toolType = type;
            //this.selectorTabs = [],
            this.selectorTabIndex = 0;
            this.selectorList = [];
            this.searchText = '';
            
            if(this.toolType != 'emoji') {
                this.showEmoji = false;
                if(this.toolType == 'circle_cat'){
                    if(!this.circleList.length) {
                        this.getHotCircles();
                    }else{
                        this.selectorList = this.circleList[this.selectorTabIndex].list;
                    }
                    
                    this.$nextTick(() => {
                        if(this.$refs.scrollTab) {
                            this.scroll = new BScroll(this.$refs.scrollTab, {
                                scrollX: true,
                                probeType: 3, // listening scroll event
                                click:true    
                            })
                        }
                    });
                }
                
                else if(this.toolType == 'topic') {
                    if(!this.topicList.length) {
                        this.getTopics();
                    }else{
                        this.selectorList = this.topicList;
                    }
                }
                else if(this.toolType == 'video') {
                    // 触发文件选择对话框
                    this.$refs.videoInput.click();
                }
            }else{
                this.showEmoji = !this.showEmoji
            }
            
            this.toolPosition(event);
        },
        isToolDisabled(tool) {
            const mergedRole = { ...this.currentUser.media_role, ...this.currentUser.type_role }; // 合并权限配置
            
             if (mergedRole[tool] !== undefined && mergedRole[tool] === false) {
                return true; // 如果权限存在且为false，则禁用工具
            } else {
                return false; // 其他情况不禁用工具
            }
        },
        handleInput() {
            if(this.searchText.trim()) {
                this.selectorList = [];
                this.loading = true;
            }
            // 如果不是中文输入状态，则调用getSuggestions方法
            if (!this.composing) {
                clearTimeout(this.typingTimer);
                this.typingTimer = setTimeout(() => {
                    this.getSearchCircle();
                }, 500);
            }
        },
        handleClick(emoji) {
            //this.$refs.momentContent.value += "["+ emoji.name +"]";
            this.content += "["+ emoji.name +"]";
            this.$refs.momentContent.focus()
        },
        showImgUploadBox () {
            this.$createModal('imageUploadBox',{size:400,props:{
                data:{
                    showTabType:1,
                    maxPicked:this.image.count,
                    postType:'circle',
                    callback:(data,type) => {
                        this.image.list.push(...data);
                    }
                }
                
            }})
        },
        changeVideoThumb(data) {
            if(!data) {
                this.$createModal('imageUploadBox',{size:400,props:{
                    data:{
                        showTabType:2,
                        maxPicked:1,
                        postType:'circle',
                        callback:(data,type) => {
                           data.length && (this.video.thumb = data[0]);
                        }
                    }
                    
                }})
            }else{
                this.video.thumb = data
            }
        },
        fileUpload(event) {
            if(this.locked == true) return
            this.locked = true
            
            for (let i = 0; i < event.target.files.length; i++) {
                let file = event.target.files[i]
                let url = URL.createObjectURL(file)
                
                if(file.size <= this.editor.media_size.video * 1024000) {
    
                    // 检查是否已经上传过
                    if(this.video.list.findIndex(item => item.name === file.name && item.size === file.size) !== -1) {
                        setTimeout(()=> {
                            this.$message({ message: `文件[${file.name}]已经上传过，请选择其他文件`, type: 'warning' });
                        }, 300);
    
                        this.locked = false
                        continue
                    }
                    this.video.list.splice(i,1,{
                        'id':'',
                        'url':url,
                        'name':file.name,
                        'thumbList':Array(4).fill(''),
                        'progress':0,
                        'success':false,
                        'size': file.size,
                    })
                    
                    this.video.thumb = '';
                    
                    getVideoCover(file, 4).then((thumbList)=>{
                        this.video.list[i].thumbList = thumbList.map((value, index) => {
                            return {
                                url:URL.createObjectURL(value),
                                file:value
                            };
                        });
                        this.video.thumb = this.video.list[i].thumbList[0]
                    }).catch(() => {});
                    
                    let formData = new FormData()
                    formData.append('file', event.target.files[i], event.target.files[i].name)
                    formData.append("post_id", 1)
                    formData.append("type", 'circle')

                    const config = {
                        onUploadProgress: (progress) => {
                            this.video.list[i].progress = Math.floor(progress.loaded/progress.total*100)
                        },
                    }
    
                    this.$http.post(qk_rest_url + 'fileUpload',formData,config).then(res=>{
    
                        this.video.list[i].url = res.data.url
                        this.video.list[i].id = res.data.id
                        this.video.list[i].success = true
                        this.locked = false
    
                    }).catch(err=>{
                        this.$message({ message: qkGetApiError(err, '网络原因上传失败，请重新上传'), type: 'warning' });
                        this.video.list.splice(i, 1);
                        this.locked = false
                    })
    
                }else {
                    setTimeout(()=> {
                        this.$message({ message: "文件[" + file.name + "]大小超过限制"+this.editor.media_size.video+"M，请重新选择", type: 'error' });
                        this.locked = false
                    }, 300);
                }
            }
    
            this.$refs.videoInput.value = "" // 清空选择的文件
        },
        videoThumbUpload(){
            
            if(!this.video.list.length || !this.video.thumb.file) return Promise.resolve()
            
            let videoImg = new FormData()
            let fimeName = this.video.list[0].url.substring(0, this.video.list[0].url.lastIndexOf('.'))+'.jpg';
            fimeName = fimeName.substring(fimeName.lastIndexOf('/')+1,fimeName.length)
            videoImg.append('file',this.video.thumb.file,fimeName)
            videoImg.append("post_id", 1)
            videoImg.append("set_poster", this.video.list[0].id)
            //videoImg.append("file_name", fimeName)
            videoImg.append("type", 'circle')

            return this.$http.post(qk_rest_url+'fileUpload',videoImg).then(res=>{
                this.video.thumb = res.data
            }).catch((err) => {
                this.$message({ message: qkGetApiError(err, '封面上传失败'), type: 'warning' });
            })
        },
        getEditMomentData() {
            let post_id = qkGetQueryVariable('id')
            let topic = qkGetQueryVariable('topics')
            if(topic && !post_id){
                this.content += "#"+ topic.trim() +"#";
                this.$refs.momentContent.focus();
            }
            
            if(!this.circle || !this.circle.can_edit || !post_id) return
            
            this.$http.post(qk_rest_url + 'getEditMomentData', 'post_id=' + post_id).then(res=>{
                this.moment_id = res.data.id;
                this.title = res.data.title;
                this.content = res.data.content;
                this.momentType = res.data.type; //帖子类型 比如投票等等
                this.momentTag = res.data.tag;
                this.image.list = res.data.image;
                this.video.list = res.data.video;
                if(this.video.list.length){
                    this.video.thumb = res.data.video[0].thumbList[0]
                }
                this.privacy = {...this.privacy,...res.data.privacy};
                this.$nextTick(()=>{
                   autosize.update(this.$refs.momentContent);
                })
            }).catch(err=>{
                this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
            })
        },
        privacytoolViewClose() {
            this.privacy.type = 'none';
            this.privacy.value = '';
            this.privacy.roles = [];
            this.privacy.content = '';
        },
        toolPosition(event) {
            this.$nextTick(()=>{
                // 获取父元素的位置和大小信息
                const parentRect = this.$el.getBoundingClientRect();
                //可以通过event.currentTarget来获取当前被点击的元素
                const targetRect = event.currentTarget.getBoundingClientRect();

                  // 计算组件应该显示的位置
                const left = targetRect.left - parentRect.left + window.pageXOffset;
                // 获取浏览器窗口的宽度和高度
                const windowWidth = window.innerWidth || document.documentElement.clientWidth;

                // 计算组件的边界
                const componentWidth = document.querySelector('.tool-view-item').offsetWidth;

                const maxLeft = windowWidth - componentWidth - 16; // 留有12px的间隙
                // 根据浏览器边界调整组件的位置
                const adjustedLeft = Math.min(Math.max(left, 12), maxLeft);
                  // 设置组件的位置
                //document.querySelector('.selector-container').style.left = adjustedLeft + 'px';
                
                const circleElements = document.querySelector('.circle-editor-tool-view').children;

                 Array.from(circleElements).forEach(item => {
                    if (item.style.display !== 'none') {
                        item.style.left = adjustedLeft + 'px';
                    }
                });
            })
        },
        TabscrollTo(index) {
            var dom = this.$refs.scrollTab.children[0]
    
            var clientWidth = this.$refs.scrollTab.clientWidth //父元素宽度scroll-tab-wrapper
            var offsetLeft =  dom.children[index].offsetLeft //li 距离左侧宽度
            var offsetWidth = dom.children[index].offsetWidth //li 当前元素宽度
            
            if(clientWidth > dom.clientWidth) return;
    
            var left = offsetLeft - clientWidth/2 + offsetWidth/2
            left = left < 0 ? 0 : left  //最左
    
            left = left + clientWidth >= dom.scrollWidth ? dom.scrollWidth - clientWidth : left //最右
            this.scroll.scrollTo(-left, 0, 300)
        },
    },
    watch: {
        // '$refs.momentContent.value': {
        //     handler(newVal) {
        //       // 检查是否包含旧的话题，并删除之的输入
        //           var regex = /#[^#]+#/g;
        //           var matches = inputValue.match(regex);
        //           if (matches && matches.length > 1) {
        //             var lastIndex = inputValue.lastIndexOf(matches[matches.length - 1]);
        //             inputBox.value = inputValue.substring(lastIndex);
        //           }
        //     },
        // },
        searchText() {
            this.searchText = this.searchText.trim()
            if(!this.searchText) {
                if(this.toolType == 'topic') {
                    this.selectorList = this.topicList
                }else if(this.toolType == 'circle_cat' && this.circleList.length){
                    this.selectorList = this.circleList[this.selectorTabIndex].list;
                }
            }
        }
        
    }
};
